var getSwatchData_gql_default = `
query GetSwatchData($attributeCode: String!) {
  WmAttributeSwatchData(attribute_code: $attributeCode) {
    items {
      label
      type
      value
    }
  }
}
`;
export {
  getSwatchData_gql_default as default
};
